// extracted by mini-css-extract-plugin
export default {"markAsCollectedActionCenter":"MarkAsCollectedActionCenter__markAsCollectedActionCenter-latK","icon":"MarkAsCollectedActionCenter__icon-Lv2u"};